<script>
export default {
    name: 'ErrorResponse',
}
</script>

<template>
  <div class="status-message error">
    <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
    </svg>
    <span>Payment unsuccessful. The transaction was not completed. Please try again or contact our support team if you continue experiencing issues. If you need assistance, email us at <a href="mailto:support@cartum.io">support@cartum.io</a></span>
  </div>
</template>

<style scoped>
.status-message {
  padding: 16px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  font-size: 15px;
  line-height: 1.5;
}

.status-message.error {
  background-color: #fef2f2;
  border: 1px solid #fee2e2;
  color: #991b1b;
}

.status-message.error .icon {
  color: #dc2626;
}

.status-message .icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.status-message.error a {
  color: inherit;
  text-decoration: underline;
}

.status-message.error a:hover {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Stripe/ErrorResponse.vue